















import { ref } from '@vue/composition-api';
import SecureMfa from '@/components/secure/SecureMfa.vue';

export default {
  name: 'SecureView',
  components: {
    SecureMfa
  },
  setup(): Record<string, unknown> {
    const isMfaExpanded = ref<boolean>(false);

    return {
      isMfaExpanded
    };
  }
};
